import { toast } from "sonner";
import { useSite } from "../../context/SiteContext";
import { checkoutUrl } from "../../lib/core";
import { track } from "../../lib/pixel";

export const BookButton = ({ plan, variant = "gold", size = "lg", className = "", children, testid }) => {
  const { pricing } = useSite();
  const isTrio = plan === "trio";

  const onClick = () => {
    const tier = pricing?.tier || {};
    const price = isTrio ? tier.trio_price : tier.single_price;
    track("InitiateCheckout", {
      value: typeof price === "number" ? price : 0,
      currency: "INR",
      content_name: isTrio ? "Power Trio" : "Single Pass",
    });
    const url = checkoutUrl(isTrio ? tier.trio_url : tier.single_url);
    if (!url) {
      toast.error("Checkout link is being set up. Please message us on WhatsApp to book.");
      return;
    }
    window.location.href = url;
  };

  const base =
    variant === "link"
      ? "inline-flex items-center justify-center text-center text-[15px] font-semibold text-[#F5D77A] underline decoration-[#D4AF37]/60 underline-offset-4 transition-colors hover:text-white"
      : `inline-flex items-center justify-center rounded-full text-center leading-snug tracking-wide ${
          size === "sm" ? "min-h-[46px] px-6 py-2 text-sm" : "min-h-[60px] px-6 py-3 text-[17px] sm:text-lg"
        } ${variant === "gold" ? "btn-gold" : "btn-ghost-gold font-bold"}`;

  return (
    <button type="button" data-testid={testid} onClick={onClick} className={`${base} ${className}`}>
      {children}
    </button>
  );
};

export const TicketCtas = ({ idPrefix = "hero", className = "" }) => {
  const { pricing, fmt } = useSite();
  const t = pricing?.tier || {};
  return (
    <div className={`flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:justify-center ${className}`}>
      <BookButton plan="single" testid={`${idPrefix}-primary-cta`} className="w-full sm:w-auto sm:px-9">
        Book My Seat – {fmt(t.single_price)} + GST
      </BookButton>
      <BookButton plan="trio" variant="ghost" testid={`${idPrefix}-secondary-cta`} className="w-full sm:w-auto sm:px-9">
        3 Seats @ {fmt(t.trio_price)} + GST
      </BookButton>
    </div>
  );
};

export const SeatLine = ({ className = "", testid }) => (
  <span data-testid={testid} className={`inline-flex items-center gap-2 ${className}`}>
    <span className="relative flex h-2.5 w-2.5">
      <span className="pulse-ring absolute inline-flex h-full w-full rounded-full bg-[#F5D77A]" />
      <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-[#F5D77A]" />
    </span>
    Limited seats
  </span>
);
